import NeuralBackdrop from './ui/NeuralBackdrop';

export default function SpatialLayout({ children }) {
  return (
    <div className="relative min-h-screen w-full selection:bg-nilyTeal selection:text-void bg-void">
      {/* Global 3D Background - Z-0 and NO POINTER EVENTS */}
      <div className="fixed inset-0 z-0 pointer-events-none">
        <NeuralBackdrop />
      </div>
      
      {/* Content Z-Layer - Z-10 and ALLOWS CLICKS */}
      <main className="relative z-10 w-full pointer-events-auto">
        {children}
      </main>
    </div>
  );
}
